enum PolicyTerms {
  IPT_ORV_2020_12 = 'IPT_ORV_2020_12',
  IPTS_ORV_2020_12 = 'IPTS_ORV_2020_12',
  UNKNOWN = 'UNKNOWN',
}

export default PolicyTerms;
